import React, { useEffect } from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';

const BancoDeMidias = () => {
  const [bancoMidiasUrl, setBancoMidiasUrl] = React.useState('');

  const [userData, setUserData] = React.useState(null);

  useEffect(() => {
    const baseUrlMidias = process.env.REACT_APP_BASEURL_BANCOMIDIAS;
    setBancoMidiasUrl(baseUrlMidias);

    const userStorage = JSON.parse(localStorage.getItem('midias_camil_site'));

    setUserData(userStorage);

    if (userStorage.token_BancoDeMidias) {
      window.location.href = `${baseUrlMidias}/${userStorage.token_BancoDeMidias}`;

      // const urlRedirect = `${baseUrlMidias}/${userStorage.token_BancoDeMidias}`;
      // window.open(urlRedirect, '_blank');
    }
  }, []);

  return (
    <>
      <Header />
      <a href={`${bancoMidiasUrl}/${userData?.token_BancoDeMidias || ''}`}>
        <div>
          <div>Banco de Mídias</div>
        </div>
      </a>
      <Bottom />
    </>
  );
};

export default BancoDeMidias;
